import * as React from "react"
import { selectedTheme } from "../../utils/constant";
import { useTheme } from "@mui/material";
const CalSvgComponent = (props) => {
  const {width=27,height=26,...restOfProps} = props;
  const theme = useTheme();
  const main = theme.palette.primary.main;
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <path
      fill={main}
      fillRule="evenodd"
      d="M18.814 10.014a7.763 7.763 0 0 0-7.758 7.759 7.762 7.762 0 0 0 7.758 7.758 7.762 7.762 0 0 0 7.759-7.758 7.762 7.762 0 0 0-7.759-7.76ZM.723 12.6v9.006a2.571 2.571 0 0 0 2.571 2.57h6.9a.863.863 0 0 0 0-1.723h-6.9a.847.847 0 0 1-.847-.847V12.6a.863.863 0 0 0-1.724 0Zm17.23 1.714v3.459c0 .326.184.625.476.77l2.755 1.378a.862.862 0 0 0 .771-1.542l-2.278-1.139v-2.926a.863.863 0 0 0-1.725 0Zm-12.5 4.32h2.586a.863.863 0 0 0 0-1.723H5.452a.863.863 0 0 0 0 1.724Zm0-2.585h2.586a.863.863 0 0 0 0-1.725H5.452a.863.863 0 0 0 0 1.725Zm0-2.587h2.586a.863.863 0 0 0 0-1.724H5.452a.863.863 0 0 0 0 1.724Zm7.339-10.345H7.619V1.393a.863.863 0 0 0-1.724 0v1.724H3.294A2.571 2.571 0 0 0 .723 5.688v3.464a.862.862 0 0 0 1.724 0V8.29h22.414v1.75a.863.863 0 0 0 1.724 0V5.689a2.57 2.57 0 0 0-2.57-2.57h-2.602V1.392a.862.862 0 0 0-1.725 0v1.724h-5.172V1.393a.862.862 0 0 0-1.724 0v1.724Z"
      clipRule="evenodd"
    />
  </svg>
  )
}
  

export default CalSvgComponent
